import { Leaf, Recycle, ShieldCheck, Users, type LucideIcon } from "lucide-react";

export interface CoreValue {
  icon: LucideIcon;
  title: string;
  body: string;
  example: string;
}

export const CORE_VALUES: CoreValue[] = [
  {
    icon: Leaf,
    title: "Freshness",
    body: "Every order ships within hours of landing, iced by the same crew that caught it.",
    example: "Our Kochi and Chennai hubs re-ice every shipment mid-transit rather than let a delay compromise quality.",
  },
  {
    icon: ShieldCheck,
    title: "Trust",
    body: "What you see is what shipped — traceable back to the boat and date it was caught.",
    example: "Every order is linked to its source fishery and catch date, so you can verify it yourself.",
  },
  {
    icon: Recycle,
    title: "Sustainability",
    body: "We only partner with fisheries operating inside certified sustainable-catch limits.",
    example: "1% of every order funds coastal cleanup initiatives run with our partner fishing communities.",
  },
  {
    icon: Users,
    title: "Community",
    body: "Fishermen set their own prices — no middlemen taking the margin.",
    example: "Partner families keep more of every catch's value than they did selling through traditional distributors.",
  },
];
